<template>
  <div class="row spinner-parent">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="card">
        <div class="card-header">
          <strong>Edit Announcement</strong>
        </div>

        <div v-if="source" class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="announcement-title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="announcement-title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter Title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="announcement-body" class="col-md-2">Body</label>
                  <div class="col-md-10">
                    <ckeditor id="branch-announcement-body" v-model="entity.body" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Cover</label>
                  <div class="col-md-10">
                    <image-uploader
                      :uploaded-img-url="$_coverUrl"
                      @changeFile="$_coverChange"
                      @returnedOldFile="$_coverRestore"
                      @existingFileRemoved="$_coverRemove"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-12">
                    <div class="form-group row">
                      <label for="body" class="col-md-2 form-control-label">Files</label>
                      <div class="col-md-10">
                        <dropzone
                          v-if="dropzoneOptions"
                          id="files-uploader"
                          ref="dropzone"
                          :options="dropzoneOptions"
                          :destroy-dropzone="false"
                          @vdropzone-file-added="fileUploadedSuccess"
                          @vdropzone-removed-file="fileRemoved"
                        />
                        <div v-else>Dropzone can't work without upload url.</div>
                        <!-- Select File Button -->
                        <div class="mt-3">
                          <button class="btn btn-success" @click.prevent="$refs.dropzone.dropzone.element.click()">
                            Select File
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="announcement-publish" class="col-md-2">Publish Date</label>
                  <div class="col-md-10">
                    <datepicker v-model="entity.publish_date" format="yyyy-MM-dd" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="announcement-unpublish" class="col-md-2">Unpublish Date</label>
                  <div class="col-md-10">
                    <datepicker v-model="entity.unpublish_date" format="yyyy-MM-dd" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Announcements modified successfully!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.css';
import Datepicker from '@/global/components/Datepicker';

import {
  uploadStatus,
} from '@/helpers/constants';
// Mixins
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';
import CreatePageMixin from '@/mixins/CreatePageMixin';
import CommonPageMixin from '@/mixins/CommonPageMixin';
import config from '../../../../config';

const {
  SUCCESS,
} = uploadStatus;

export default {
  name: 'EditAnnouncement',

  components: {
    dropzone: Dropzone,
    datepicker: Datepicker,
  },

  mixins: [DefaultOptionsRequests, CommonPageMixin, CreatePageMixin],

  props: {
    itemToEdit: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      source: null,
      entity: {},

      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 2048,
      },

      files: [],
      uploadedFiles: [],
      toDeleteFile: null,
    };
  },

  computed: {
    dropzoneOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.$store.state.user.accessToken.access_token}`,
          Accept: 'application/json',
        },
        method: 'POST',
        paramName: 'media',
        url: `${this.$config.app_api.host}${this.$config.app_api.prefix}announcement/${this.itemToEdit.id}/file`,
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'application/pdf',
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?',
      };
    },
    uploadingFiles() {
      const getUploadings = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadings) {
        return [];
      }
      return getUploadings(this.itemToEdit.id, 'announcement');
    },

    $_coverUrl() {
      if (!this.source) { return null; }
      if (Object.prototype.hasOwnProperty.call(this.source, 'cover') && this.source.cover) {
        return this.source.cover.public_url;
      }
      return null;
    },
    $_coverIsChanged() {
      if (!this.source.cover) {
        return !!this.entity.cover;
      }
      if (_.isObject(this.entity.cover) && this.entity.cover.id === this.source.cover.id) {
        return false;
      }
      return true;
    },
  },

  watch: {
    uploadingFiles: {
      handler(val) {
        this.uploadedFiles = val.filter(file => file.status === SUCCESS).map(file => file.file);
        const {
          dropzone,
        } = this.$refs;
        if (dropzone) {
          this.uploadedFiles.forEach(file => dropzone.removeFile(file));
          this.uploadedFiles.forEach((file) => {
            dropzone.manuallyAddFile(file, '/');
            $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src',
              'static/img/file-thumb.jpg');
          });
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.getSource();
  },

  methods: {
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}announcements/${this.itemToEdit.id}`, {
        params: {
          with: [
            'pdf',
            'cover',
            'branch',
          ],
        },
      }).then((response) => {
        this.source = response.data;
        if (!Object.prototype.hasOwnProperty.call(this.source, 'cover')) {
          this.source.cover = null;
        }
        this.entity = _.cloneDeep(this.source);
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        if (this.entity.pdf) {
          setTimeout(this.manuallyAddFiles, 100);
        }
      }).catch((error) => {
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting article request' });
        console.error('Error in get single article query', error);
      });
    },

    manuallyAddFiles() {
      const file = {
        file: {
          name: this.entity.pdf.file_name,
          size: this.entity.pdf.size,
        },
        url: this.entity.pdf.public_url,
        thumb: this.entity.pdf.thumbnail,
      };
      this.$refs.dropzone.manuallyAddFile(file.file, file.url);
      if (!this.entity.pdf.mime_type.match(/image.*/)) {
        $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', file.thumb);
      }
    },
    fileUploadedSuccess(file) {
      this.files.push(file);
    },
    fileRemoved(file) {
      this.toDeleteFile = file;
    },

    saveRequest() {
      const postFormData = new FormData();

      postFormData.append('title', this.entity.title);
      postFormData.append('branch_id', this.$route.params.id);
      if (this.entity.body) {
        postFormData.append('body', this.entity.body);
      }
      if (this.entity.publish_date) {
        postFormData.append('publish_date', this.entity.publish_date);
      }
      if (this.entity.unpublish_date) {
        postFormData.append('unpublish_date', this.entity.unpublish_date);
      }

      return this.$apiHttp.post(`${this.$config.app_api.prefix}announcements/${this.entity.id}`,
        postFormData);
    },

    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      const files = this.files.filter(file => !file.manuallyAdded);
      const { prefix, host } = this.$config.app_api;
      const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));
      const vm = this;

      if (this.toDeleteFile) {
        this.$apiHttp
          .delete(
            `${this.$config.app_api.host}${this.$config.app_api.prefix}announcements/${this.entity.id}/pdf`,
          )
          .then(() => {
            this.entity.files = [];
          })
          .catch((error) => {
            console.error('error in delete file in site page request - ', error);
          });
      }

      const dispatchStartUpload = (contentType) => {
        if (files && files.length > 0) {
          vm.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: this.entity.id,
            files: [...files],
            token,
            contentType,
          });
          vm.files = [];
        }
      };

      if (!this.$_coverIsChanged) {
        this.saveRequest()
          .then((response) => {
            $('.btn-success .btn-loader').hide();
            this.$store.commit('notifications/setSuccessNotification', 'Success!');
            dispatchStartUpload(response.data.content_type);
          })
          .then(() => {
            this.$emit('changeMode');
          })
          .catch((error) => {
            $('.btn-success .btn-loader').hide();
            this.$_errorSave(error);
            console.error('Error in update announcement query', error);
          });
      } else if (!this.entity.cover) {
        axios
          .all([this.deleteCoverRequest(), this.saveRequest()])
          .then(axios.spread((cover, entity) => {
            if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
              $('.btn-success .btn-loader').hide();
              this.$store.commit('notifications/setSuccessNotification', 'Success!');
              dispatchStartUpload(entity.data.content_type);
              this.$emit('changeMode');
            } else {
              this.$_showError('Error in data saving');
            }
          }));
      } else {
        axios
          .all([this.saveCoverRequest(), this.saveRequest()])
          .then(axios.spread((cover, entity) => {
            if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
              $('.btn-success .btn-loader').hide();
              this.$store.commit('notifications/setSuccessNotification', 'Success!');
              dispatchStartUpload(entity.data.content_type);
              this.$emit('changeMode');
            } else {
              this.$_showError('Error in data saving');
            }
          }));
      }
    },
    // Cover
    $_coverChange(file) {
      this.entity.cover = file;
    },
    $_coverRestore() {
      this.entity.cover = this.source.cover;
    },
    $_coverRemove() {
      this.entity.cover = null;
    },
    saveCoverRequest() {
      const postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}announcements/${this.entity.id}/cover`, postFormData);
    },
    deleteCoverRequest() {
      return this.$apiHttp.delete(`${this.$config.app_api.prefix}announcements/${this.entity.id}/cover`);
    },
  },
};

</script>



// WEBPACK FOOTER //
// Edit.vue?0eaf4bb4